import type { FaireProductEntity } from "../../entity_types/product";

export const p_5aeuy9zgag: FaireProductEntity = {
  token: "p_5aeuy9zgag",
  type: "product",
  name: "Dark Chocolate Sea Salt Caramels Gift Box",
  brandName: "Annie B's",
  imageUrl:
    "https://cdn.faire.com/fastly/24145c75972e4fd33be5c38be0cfe8420f1920cabb3ee86d3a7bb8963b5a3d00.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/65a292801d5eccad339a1d322567cedbd84c9b70599a5a34aa5671b5bb8b01cf.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
